import { xmlDecode } from "./util.mjs";

/**
 * Value object.
 */
export class Value {
  /**
   * Value type.
   */

  /**
   * Tag names.
   */

  /**
   * Value constructor.
   */
  constructor() {}

  /**
   * Value type.
   *
   * @returns Type string.
   */
  get type() {
    return this.constructor.TYPE;
  }

  /**
   * Cast to specific type or null.
   *
   * @param Type Type constructor.
   * @returns This object or null.
   */
  castTo(Type) {
    return this.type === Type.TYPE ? this : null;
  }

  /**
   * Cast to specific type or throw.
   *
   * @param Type Type constructor.
   * @returns This object.
   */
  castAs(Type) {
    const casted = this.castTo(Type);
    if (!casted) {
      throw new Error(`Cannot cast type '${this.type}' to '${Type.TYPE}'`);
    }
    return casted;
  }

  /**
   * Decode document from string.
   *
   * @param xml XML string.
   */
  fromXml(xml) {
    const {
      documentElement
    } = xmlDecode(xml);
    this.fromXmlElement(documentElement);
  }

  /**
   * Decode value from element.
   *
   * @param element XML element.
   */

  /**
   * Encode Value to string.
   *
   * @param options Options object.
   * @param depth Indent depth.
   * @returns Xml string.
   */
}
//# sourceMappingURL=value.mjs.map